export default {
	alarms: true,
	audio: true,
	audioCapture: true,
	background: true,
	browser: true,
	certificateProvider: true,
	clipboard: true,
	clipboardRead: true,
	clipboardWrite: true,
	contextMenu: true,
	desktopCapture: true,
	diagnostics: true,
	displaySource: true,
	dns: true,
	documentScan: true,
	"enterprise.deviceAttributes": true,
	"enterprise.platformKeys": true,
	experimental: true,
	fileBrowserHandler: true,
	fileSystem: true,
	fileSystemProvider: true,
	gcm: true,
	geolocation: true,
	hid: true,
	identity: true,
	idle: true,
	mdns: true,
	mediaGalleries: true,
	nativeMessaging: true,
	"networking.config": true,
	"networking.onc": true,
	notifications: true,
	platformKeys: true,
	pointerLock: true,
	power: true,
	printerProvider: true,
	proxy: true,
	serial: true,
	signedInDevices: true,
	socket: true,
	storage: true,
	syncFileSystem: true,
	"system.cpu": true,
	"system.display": true,
	"system.memory": true,
	"system.network": true,
	"system.powerSource": true,
	"system.storage": true,
	tts: true,
	unlimitedStorage: true,
	usb: true,
	videoCapture: true,
	virtualKeyboard: true,
	vpnProvider: true,
	wallpaper: true,
	webview: true,
};
